import { useQuery } from 'react-query';

import { getEmployerCostSettingById } from 'RestAPIs/admin';

export const useGetEmployerCostSetting = (id) => {
  const { data, isFetching, isError } = useQuery({
    queryKey: ['employerCostSetting', id],
    queryFn: async () => {
      const { data } = await getEmployerCostSettingById(id);
      return data;
    },
    enabled: !!id
  });

  return { isFetching, data, isError };
};
